import { Component, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { TextInput } from '../../../../../../components/text-input/text-input';
import { LocalDropdown } from '../../../../../../components/local-dropdown/local-dropdown';
import { LegalEntityDropdown } from '../../../../../../features/finances/components/legal-entity-dropdown/legal-entity-dropdown';
import { UserFormModel } from '../../models/user-form-model';
import { UserFormValue } from '../../models/user-form-value';

@Component({
  selector: 'elcia-user-form',
  imports: [ReactiveFormsModule, TranslatePipe, TextInput, LocalDropdown, LegalEntityDropdown],
  templateUrl: './user-form.html',
})
export class UserForm {
  onSubmit = output<UserFormValue>();

  protected readonly form = new FormGroup<UserFormModel>({
    email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
    password: new FormControl<string | null>(null, Validators.required),
    firstName: new FormControl<string | null>(null, Validators.required),
    lastName: new FormControl<string | null>(null, Validators.required),
    legalEntityId: new FormControl<number | null>(null, Validators.required),
    localeIsoCode: new FormControl<string | null>(null, Validators.required),
  });

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.onSubmit.emit(this.form.getRawValue());
  }
}
